import React from "react";

import { HeroGuideBlock as Value } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ButtonPrimary } from "../Clickables";
import { H, HLevel } from "../Headings";
import { getThemeClass } from "../ThemedModule";

import styles from "./HeroGuide.module.scss";

export const HeroGuide = ({ value }: { value: Value }) => (
    <HLevel>
        <section
            className={concatClassNames([
                styles.root,
                getThemeClass(value.module_theme),
            ])}
        >
            <div className={styles.content}>
                <H className={styles.headline}>{value.headline}</H>
                {value.body && <p className={styles.body}>{value.body}</p>}
                {value.cta?.url && (
                    <div className={styles.ctaWrapper}>
                        <ButtonPrimary simpleLink={value.cta} />
                    </div>
                )}
            </div>
            {value.graphic && (
                <div className={styles.imageWrapper}>
                    <ImageChooserBlock value={value.graphic} attrs={{}} />
                </div>
            )}
        </section>
    </HLevel>
);
